import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export type SpinnerSize = "sm" | "md" | "lg";

const SIZE_MAP: Record<SpinnerSize, number> = {
  sm: 14,
  md: 24,
  lg: 40,
};

type Props = {
  size?: SpinnerSize;
  color?: string;
  // When true, wrap the spinner in a centered flex container with vertical padding.
  // Use for section/card-level loading states.
  center?: boolean;
  className?: string;
};

export const Spinner: React.FC<Props> = ({
  size = "md",
  color,
  center,
  className,
}) => {
  const spinner = (
    <ClipLoader size={SIZE_MAP[size]} color={color} loading={true} />
  );
  if (!center) {
    return (
      <span className={className} style={{ display: "inline-flex" }}>
        {spinner}
      </span>
    );
  }
  return (
    <div
      className={className}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1.5rem 0",
      }}
    >
      {spinner}
    </div>
  );
};

export default Spinner;
